var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-layout-main"},[_c('div',{staticClass:"setting-title shareUrl"},[_c('a',{attrs:{"href":_vm.currentSoundUrl},on:{"click":function($event){$event.preventDefault();return _vm.copyText.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.currentSoundUrl))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }